import React from 'react';
import { Grid, Message } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { Button } from 'semantic-ui-react';
import logo from "../../images/logo/logo-full-black.png";
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import LoadingComponent from "../common/LoadingComponent";
import ModalHeader from './../drive/ModalHeader';
import mailImage from './../../images/grafix-banner/gfx-account-success.svg';
class SetupCredentials extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formSubmitted: false,
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.goToLogin = this.goToLogin.bind(this);
        this.goToForgetPassword = this.goToForgetPassword.bind(this);
    }

    async onSubmit(formData) {
        this.setState({formSubmitted:true});
        await dispatch.registerAccount.getUser(formData);
        if(this.props.userForVerification && !this.props.userForVerification.isVerified){
            const { history } = this.props;
            history.push('/updatePassword/' + this.props.userForVerification._id);
        }
    }

    goToLogin(e) {
        e.preventDefault();
        const { history } = this.props;
        history.push('/login');
    }

    goToForgetPassword(e) {
        e.preventDefault();
        const { history } = this.props;
        history.push('/forgotpassword');
    }

    render() {

        const { userForVerification, loading, verifyUserError } = this.props;
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <div className="inner setup-credentials-wrap">
                <ModalHeader
                    header={<img src={`${logo}`} alt='' />}
                    subHeader="Welcome!" />
                <Grid>
                    <Grid.Column width={3} className="setup-credentials-side" />
                    <Grid.Column width={10} className="setup-credentials-main">
                        <LoadingComponent active={loading} message="loading..." />
                        {this.state.formSubmitted === true && !loading && userForVerification && userForVerification.isVerified?
                            <div className="ModalContent">
                                <div ><img src={mailImage} height="160" alt='' /> </div>
                                <div className={` error_text2 clr-green`}></div><br />
                                <span className="error_text3">
                                    <p>
                                        You have already verified your account. If you don't remember your password. Please use the <a onClick={this.goToForgetPassword} className="cursor-pointer"><strong>“Forgot Password”</strong></a> option to reset it.<br />
                                        <a onClick={this.goToLogin} className="cursor-pointer">Click here</a> to go to the login page
                                    </p>
                                </span>
                            </div>

                            : <Form
                                className="loginform"
                                error
                                ref={ref => this.form = ref}
                                onValidSubmit={this.onSubmit}
                            > {verifyUserError ?
                                <Message
                                    error
                                    content={`Invalid Email Address!`}
                                /> : ''}
                                <Form.Input
                                    name="email"
                                    label="Email"
                                    placeholder="Email"
                                    icon="envelope"
                                    iconPosition="left"
                                    required
                                    validations="isEmail"
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        isEmail: 'This is not a valid email',
                                        isDefaultRequiredValue: 'Email is required',
                                    }}
                                    id="emailId"
                                />


                                <span className="actionInFormcy border-none">
                                    <Button className="button-submit float-right mar_0" type="submit" id="submit">Submit</Button>
                                    <a href="#" className="float-left typeAnchor" onClick={this.goToLogin} id="loginLink">Back to Login</a>
                                </span>
                            </Form>
                        }
                    </Grid.Column>
                </Grid>

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        userForVerification: state.registerAccount.userForVerification,
        loading: state.loading.effects.registerAccount.getUser,
        verifyUserError: state.registerAccount.verifyUserError
    };
}

const connectedLoginPage = connect(mapStateToProps)(SetupCredentials);

export {connectedLoginPage as SetupCredentials};


